<template>
  <v-container fluid pa-0 ma-0 fill-height>

    <v-toolbar class="pa-0 ma-0 toolbar-shadow"
               color="white" flat fixed>
      <v-btn flat @click="$router.go(-1)" color="#4a4a4a" style="min-width: 0; font-size: 16px;">취소</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat
             @click.stop="sheet = true"
             style="font-size: 16px; font-weight: 700; letter-spacing: -0.3px;"
             :color="menuIdx ? '#4a4a4a': '#9497b2'">
        {{ menuIdx ? nationIdx ? `${menuName} / ${nationName}` : `${menuName}` : '주제 선택' }}
        <v-icon size="20px" class="ml-1">$vuetify.icons.arrowDown</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn flat
             color="#4a4a4a"
             style="min-width: 0; font-size: 16px;"
             :loading="loading"
             :disabled="loading || !content || !title"
             @click="submit">
        등록
      </v-btn>
    </v-toolbar>

    <v-layout column class="ma-0 fill-height">
      <v-card flat tile class="ma-0 px-0 fill-height"
              style="padding-top: 56px;"
              :style="{ paddingBottom: files.length ? '139px !important' : '49px !important' }">
        <div class="input-title-holder">
          <input placeholder="제목을 입력하세요." v-model="title">
        </div>
        <div class="input-content-holder">
          <textarea autocomplete="off" autocapitalize="none" spellcheck="false"
                    v-model="content"
                    :placeholder="randomPlaceholder">
          </textarea>
        </div>
      </v-card>

      <v-card flat tile class="ma-0 pa-0" style="position: fixed; bottom: 0; width: 100%;">
        <v-layout row wrap>

          <v-flex xs12 v-if="files.length" class="mb-2">
            <v-card flat tile class="pa-0 ma-0 overflow-x-hidden">
              <v-card-text class="ma-0 pa-0 overflow-y-hidden" style="height: 82px;">
                <v-layout class="d-block overflow-y-hidden" style="height: 500px; overflow-x: scroll;" ref="imageHolder">
                  <div style="display: flex; flex-wrap: nowrap; text-align: left;">
                    <v-flex v-for="(image, index) of files" :key="index"
                            class="d-inline-block grid-padding" style="flex-grow: 0; flex-shrink: 0;">
                      <v-img width="82" height="82" aspect-ratio="1"
                             class="text-xs-right"
                             style="flex-grow: 0; border-radius: 3px"
                             :src="image.url"
                             @load="onImageLoad">
                        <v-icon dark size="17" class="mr-1" @click="deleteFile(image.idx)">$vuetify.icons.cancel</v-icon>
                      </v-img>
                    </v-flex>
                  </div>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 class="px-3 py-2" style="border-top: 1px solid #eaeaea;">
            <v-layout row justify-end>
              <div class="ml-2">
                <input ref="imgUpload" name="img-uploads" type="file" accept="image/*" multiple @change="onFileChanged" style="display: none;">
                <v-btn icon class="ma-0" style="width: 32px; height: 32px;" @click="$refs.imgUpload.click()">
                  <v-icon color="#4a4a4a" size="32px">$vuetify.icons.image</v-icon>
                </v-btn>
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- 임시 스낵바 -->
      <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
        {{ snackbarMessage }}
        <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
      </v-snackbar>

    </v-layout>

    <v-bottom-sheet v-model="sheet">
      <v-card class="bottom-sheet-custom">
        <div class="bottom-sheet-custom-holder">
          <div class="bottom-sheet-custom-gradient-holder"></div>

          <div class="filter-swiper-container swiper-container" style="width: 100%;">
            <div class="filter-swiper-wrapper swiper-wrapper">
              <div class="filter-swiper-slide swiper-slide">
                <v-subheader style="padding: 0 32px; display: flex; justify-content: space-between">
                  <span>필수 선택</span>
                  <v-icon>$vuetify.icons.arrowStickRight</v-icon>
                </v-subheader>
                <v-list class="pa-0">
                  <v-list-tile v-for="menu of communityMenu" :key="menu.code"
                               class="nation-list-tile"
                               @click="changeFilter(menu.idx, menu.name)">
                    <span>{{ menu.name }}</span>
                    <v-icon color="#ec2f54" size="24px" v-if="menuIdx === menu.idx">$vuetify.icons.confirm</v-icon>
                  </v-list-tile>
                </v-list>
              </div>

              <div class="filter-swiper-slide swiper-slide">
                <v-list class="pa-0">
                  <v-subheader style="padding: 0 32px; display: flex; justify-content: space-between">
                    <span>부가 선택</span>
                    <v-icon>$vuetify.icons.arrowStickLeft</v-icon>
                  </v-subheader>
                  <v-list-tile v-for="nation of communityNations" :key="nation.code"
                               class="nation-list-tile"
                               @click="changeFilter(undefined, undefined, nation.idx, nation.name)">
                    <span>{{ nation.name }}</span>
                    <v-icon color="#ec2f54" size="24px" v-if="nationIdx === nation.idx">$vuetify.icons.confirm</v-icon>
                  </v-list-tile>
                </v-list>
              </div>
            </div>
          </div>

<!--          <div class="filter-swiper-pagination swiper-pagination"></div>-->
          <div class="sheet-submit-button">
            <v-btn flat small class="ma-0"
                   v-if="content && title"
                   color="#4a4a4a"
                   style="min-width: 0; font-size: 16px;"
                   :loading="loading"
                   :disabled="!menuIdx"
                   @click="submit">
              등록
            </v-btn>
          </div>

        </div>
      </v-card>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import EXIF from 'exif-js';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'WriteForm',
    // props: [ 'channelIdx', 'channelTitle' ],
    data () {
     return {
       loading: false,
       files: [],
       fileCnt: 0,
       title: '',
       content: '',
       snackbarMessage: '',
       snackbar: false,
       sheet: false,
       filterSwiper: null,
       menuIdx: 0,
       menuName: '',
       nationIdx: 0,
       nationName: '',
     };
    },
    computed: {
      ...mapGetters(['communityNations', 'communityMenu']),
      randomPlaceholder () {
        return Math.floor(Math.random() * 100) === 0 ? '어떤 이야기를 해볼까요? ᕕ( ͡°   ͜ʖ ͡°)ᕗ' : '어떤 이야기를 해볼까요? ᕕ( ᐛ )ᕗ ';
      }
    },
    created () {
      // if (typeof this.channelTitle === 'undefined') this.$router.replace({ name: 'Home' });
    },
    watch: {
      sheet (isOpen) {
        if (isOpen) {
          this.$nextTick(() => {
            if (!this.filterSwiper) {
              this.filterSwiper = new Swiper('.filter-swiper-container', {
                direction: 'horizontal',
                slidesPerView: 1,
                // pagination: {
                //   el: '.filter-swiper-pagination'
                // },
                navigation: {
                  nextEl: '.youth-icon-arrow-stick-right',
                  prevEl: '.youth-icon-arrow-stick-left',
                },
              });
            } else {
              this.filterSwiper.update();
            }
          });
        }
      }
    },
    methods: {
      ...mapActions('post', [ 'createPost' ]),
      changeFilter (menuIdx, menuName, nationIdx, nationName) {
        if (typeof menuIdx !== 'undefined') {
          this.menuIdx = menuIdx !== this.menuIdx ? menuIdx : 0;
          this.menuName = menuName !== this.menuName ? menuName : '';
        }
        if (typeof nationIdx !== 'undefined') {
          this.nationIdx = nationIdx !== this.nationIdx ? nationIdx : 0;
          this.nationName = nationName !== this.nationName ? nationName : '';
        }
      },
      onImageLoad () {
        this.$refs.imageHolder.scrollTo(this.$refs.imageHolder.scrollWidth, 0);
      },
      submit () {
        if (!this.menuIdx) {
          this.sheet = true;
          return;
        }
        this.loading = true;
        let formData = new FormData();
        formData.append('type', 'feed');
        formData.append('menu_idx', this.menuIdx);
        if (this.nationIdx) formData.append('nation_idx', this.nationIdx);
        formData.append('title', this.title);
        formData.append('contents', this.content);
        if (this.files.length) {
          for (let i = 0; i < this.files.length; i++) {
            formData.append('files', this.files[i].file);
          }
        }
        this.createPost(formData).then(response => {
          console.log(response);
          setTimeout(() => {
            // this.$router.replace({ name: 'Channel', params: { idx: this.channelIdx }});
            this.loading = false;
            this.$router.go(-1);
          }, 500);
        }).catch(err => {
          console.error(err);
          this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해 보세요.');
          this.loading = false;
        });
      },
      onFileChanged (event) {
        let totalLength = event.target.files.length + this.files.length;
        if (totalLength > 10) {
          this.showSnackbar('사진은 최대 10개까지 추가할 수 있습니다.');
          return;
        }
        let length = totalLength > 10 ? 10 - this.files.length : event.target.files.length;
        for (let i = 0; i < length; i++) {
          let file = event.target.files[i];
          if (/^image\//i.test(file.type)) {
            this.readFile(file);
          }
        }
      },
      deleteFile (idx) {
        const deletedIdx = this.files.findIndex(el => {
          return el.idx === idx;
        });
        this.files.splice(deletedIdx, 1);
      },
      showSnackbar (message) {
        this.snackbarMessage = message;
        this.snackbar = true;
      },
      // image file read & process start
      readFile (file) {
        const root = this;
        let reader = new FileReader();
        reader.onloadend = function () {
          root.processFile(reader.result, file.type);
        };
        reader.onerror = function () {
          root.showSnackbar('파일을 읽는 도중 오류가 발생했습니다.');
        };
        reader.readAsDataURL(file);
      },
      processFile (dataURL, fileType) {
        const root = this;
        let maxWidth = 2000;
        let maxHeight = 2000;
        let image = new Image();
        image.src = dataURL;
        image.onload = function () {
          let width = image.width;
          let height = image.height;
          let shouldResize = (width > maxWidth) || (height > maxHeight);
          if (!shouldResize) {
            root.appendFile(dataURL);
            return;
          }
          let newWidth, newHeight;
          if (width > height) {
            newHeight = height * (maxWidth / width);
            newWidth = maxWidth;
          } else {
            newWidth = width * (maxHeight / height);
            newHeight = maxHeight;
          }
          let canvas = document.createElement('canvas');
          canvas.width = newWidth;
          canvas.height = newHeight;
          let context = canvas.getContext('2d');
          EXIF.getData(image, () => {
            const tags = EXIF.getAllTags(image);
            console.log(tags);
            root.transformCoordinates(canvas, tags);
          });
          context.drawImage(this, 0, 0, newWidth, newHeight);
          dataURL = canvas.toDataURL(fileType);
          root.appendFile(dataURL);
        };
        image.onerror = function () {
          root.showSnackbar('파일을 처리하는 도중 오류가 발생했습니다.');
        };
      },
      appendFile (dataURL) {
        const blob = this.dataURItoBlob(dataURL);
        this.files.push({ idx: this.fileCnt, url: dataURL, file: blob });
        this.fileCnt++;
      },
      dataURItoBlob (dataURI) {
        let byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      },
      transformCoordinates (canvas, options) {
        let ctx = canvas.getContext('2d');
        let width = canvas.width;
        let height = canvas.height;
        let styleWidth = canvas.style.width;
        let styleHeight = canvas.style.height;
        let orientation = options.Orientation;
        if (!orientation || orientation > 8) return;
        if (orientation > 4) {
          canvas.width = height;
          canvas.height = width;
          canvas.style.width = styleHeight;
          canvas.style.height = styleWidth;
        }
        switch (orientation) {
          case 2:
            // horizontal flip
            ctx.translate(width, 0);
            ctx.scale(-1, 1);
            break;
          case 3:
            // 180° rotate left
            ctx.translate(width, height);
            ctx.rotate(Math.PI);
            break;
          case 4:
            // vertical flip
            ctx.translate(0, height);
            ctx.scale(1, -1);
            break;
          case 5:
            // vertical flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.scale(1, -1);
            break;
          case 6:
            // 90° rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(0, -height);
            break;
          case 7:
            // horizontal flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(width, -height);
            ctx.scale(-1, 1);
            break;
          case 8:
            // 90° rotate left
            ctx.rotate(-0.5 * Math.PI);
            ctx.translate(-width, 0);
            break;
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    padding: 0;
    border-bottom: 2px solid #f4f4f4;
    /*box-shadow: 0 4px 36px rgba(234, 234, 234, 50);*/
  }

  .input-title-holder {
    margin: 0 16px;
    padding: 16px 0;
    caret-color: #ec2f54;
    border-bottom: 1px solid #eaeaea;
    input {
      outline: none;
      width: 100%;
      font-size: 16px;
      letter-spacing: -0.3px;
    }
  }

  .input-content-holder {
    height: calc(100% - 57px);
    padding: 16px 0;
    caret-color: #ec2f54;
    textarea {
      outline: none;
      width: 100%;
      height: 100%;
      font-size: 16px;
      padding: 0 16px;
      letter-spacing: -0.3px;
      resize: none;
    }
  }

  .grid-padding {
    &:first-child {
      margin-left: auto;
      padding-left: 16px;
    }
    & + & {
      padding-left: 4px;
    }
    &:last-child {
      padding-right: 16px;
    }
  }

  .bottom-sheet-custom {
    height: calc(100vh - 260px);
    border-top-right-radius: 30px;
    border-top-left-radius: 30px;
    padding-top: 27px;
    &-holder {
      position: relative;
      padding-bottom: 168px;
      height: 100%;
      overflow-y: scroll;
      border-radius: 0 !important;
    }
    &-gradient-holder {
      position: fixed;
      bottom: 0;
      width: 100vw;
      height: 168px;
      z-index: 2;
      pointer-events: none;
      background-image: linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,1));
    }
  }
  /deep/.nation-list-tile .v-list__tile {
    height: 56px;
    padding: 0 32px;

    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.36px;
    font-weight: 700;

    display: flex;
    justify-content: space-between;
  }

  /*/deep/.filter-swiper-pagination {*/
  /*  position: fixed;*/
  /*  bottom: 32px;*/
  /*  right: 24px;*/
  /*  z-index: 3;*/
  /*  .swiper-pagination-bullet + .swiper-pagination-bullet {*/
  /*    margin-left: 8px;*/
  /*  }*/
  /*  .swiper-pagination-bullet-active {*/
  /*    background: #ec2f54;*/
  /*  }*/
  /*}*/

  .v-icon.youth {
    outline: none;
  }

  .sheet-submit-button {
    position: fixed;
    bottom: 32px;
    right: 24px;
    z-index: 3;
  }
</style>
